/**
 * Privacy / Data Handling Policy — plain text public page.
 * Fetches /api/public/data-handling-policy and renders it as-is.
 * No fancy design. Intentional.
 */
import React, { useEffect, useState } from "react";

export default function PrivacyDataHandlingPage() {
  const [text, setText] = useState("Loading...");

  useEffect(() => {
    fetch(`${window.location.origin}/api/public/data-handling-policy`)
      .then((r) => (r.ok ? r.text() : Promise.reject(`HTTP ${r.status}`)))
      .then(setText)
      .catch((e) => setText(`Could not load policy: ${e}`));
  }, []);

  return (
    <div data-testid="privacy-data-handling-page" style={{ background: "#ffffff", minHeight: "100vh", padding: "32px 20px", color: "#0f172a" }}>
      <pre
        data-testid="policy-content"
        style={{
          maxWidth: 920,
          margin: "0 auto",
          fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
          fontSize: 13,
          lineHeight: 1.6,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {text}
      </pre>
    </div>
  );
}
